import type { TealiumEvent } from 'src/types/trackingData';

const MULTI_LOCATION_ADD_LOCATION_EVENT = 'multi-location-add-location-clicked';
export const multiLocationAddLocationEvent: TealiumEvent = {
  eventType: MULTI_LOCATION_ADD_LOCATION_EVENT,
};

const MULTI_LOCATION_SUBMIT_EVENT = 'multi-location-submit-clicked';
export const multiLocationSubmitEvent: TealiumEvent = {
  eventType: MULTI_LOCATION_SUBMIT_EVENT,
};

const MULTI_LOCATION_SUCCESS_EVENT = 'multi-location-success';
export const multiLocationSuccessEvent: TealiumEvent = {
  eventType: MULTI_LOCATION_SUCCESS_EVENT,
};

const MULTI_LOCATION_PARTIAL_SUCCESS_EVENT =
  'multi_location_posted_partial_succeeded';
export const multiLocationPartialSuccessEvent: TealiumEvent = {
  eventType: MULTI_LOCATION_PARTIAL_SUCCESS_EVENT,
};

const MULTI_LOCATION_FAILED_EVENT = 'multi-location-failed';
export const multiLocationFailedEvent: TealiumEvent = {
  eventType: MULTI_LOCATION_FAILED_EVENT,
};
